import script from "./DareView.vue?vue&type=script&setup=true&lang=js"
export * from "./DareView.vue?vue&type=script&setup=true&lang=js"

import "./DareView.vue?vue&type=style&index=0&id=3a98de13&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a98de13"]])

export default __exports__